import { Bank as BankModel } from 'banks/models/bank';

export const Bank = (id = new Date().valueOf()): BankModel => ({
  id,
  bankCode: `${id}`,
  bankName: `Bank Name ${id}`,
});

export default Bank;
